module.exports = __webpack_public_path__ + "static/media/sword.9616ebbf.mp3";